import React, { useEffect, useState, useCallback } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import { useTheme, useLoyalty } from "../../../hooks";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";
import GrowthCurve from "./images/growth-curve.jpg";
import Rafiki from "./images/rafiki.png";
//svgs
import {
  ChevronRightArrow,
  NoticeIconNew,
  Time as TimeIcon,
  WinnersIcon,
} from "../../../components/svgs";
import {
  Button,
  StyledText,
} from "../../../components/common/basic";
import { BackButton } from "../../../components/common";
import useSpeedShoppingPoints from "../speedShopping/hooks/useSpeedShoppingPoints";
import loadingGif from "../../../components/images/loader.gif";

const pointsBuildingEndDate = new Date('2025-02-07')

const CapturenSharePoints = () => {
  const { themeContext, theme } = useTheme();
  const { } = useLoyalty();
  const [pointsBuildingEnded, setPointsBuildingEnded] = useState(null);
  const [captureCountdown, setCaptureCountdown] = useState(null);

  const {
    userPoints,
    getLoyaltyPoints,
  } = useSpeedShoppingPoints();
  const { pointsRounded, isPromoEnded, isQualified, rank } = userPoints || {};

  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "CaptureAndSharePoints",
        firebase_screen_class: "CaptureAndSharePoints",
      })
    );
    getLoyaltyPoints({ payload: {} });
  }, []);

  const initiateCaptureCountdown = useCallback(() => {
    const targetDate = new Date(pointsBuildingEndDate);

    if (isNaN(targetDate)) {
      console.error("Invalid date format. Please provide a valid date.");
      return;
    }

    function calculateRemainingTime() {
      const now = new Date();
      const timeDiff = targetDate - now;

      if (timeDiff <= 0) {
        console.log("Countdown finished!");
        setPointsBuildingEnded(true);
        clearInterval(intervalId);
        return;
      }

      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

      const formattedTime = `${days}d:${String(hours).padStart(2, "0")}h:${String(minutes).padStart(2, "0")}m:${String(seconds).padStart(2, "0")}s`;
      setCaptureCountdown(formattedTime);
    }

    calculateRemainingTime();
    const intervalId = setInterval(calculateRemainingTime, 1000);
  }, [pointsBuildingEndDate])


  useEffect(() => {
    if (new Date() > pointsBuildingEndDate) {
      setPointsBuildingEnded(true);
    } else {
      // Run timer
      initiateCaptureCountdown();

    }
  }, []);

  return (
    <>
      <MainHolder activeTheme="#F2F2F2">
        <Children>
          <Header background={background}>
            <BackButton
              onClick={() => {
                history.goBack();
              }}
            />
            <div style={{ textAlign: "center", marginBottom: "30px" }}>
              <div>
                <StyledText
                  style={{ fontFamily: "MTNMedium", margin: 0, padding: 0, opacity: pointsRounded === -1 ? 1 : 0 }}
                  color="white"
                  size={12}>
                  Fetching points...
                </StyledText>
              </div>
              <StyledText
                style={{ fontFamily: "MTNMedium" }}
                size={48}
                margin='0'
                color='white'
              >
                {pointsRounded === -1 ? "-" : pointsRounded}
              </StyledText>
              <StyledText
                style={{ fontFamily: "MTNRegular" }}
                size={10}
                margin='0 0 10px 0'
                color='white'
              >
                GHS 0.05 = 1 point
              </StyledText>

              <LeaderboardButton
                onClick={() => {
                  history.push("/capturenshare/leaderboard");
                }}
              />

            </div>
          </Header>

          <Body>
            <PointsInfoCard>
              {
                pointsBuildingEnded ? (<>
                  <img style={{ marginBottom: "10px" }} src={Rafiki} />
                  <StyledText style={{ margin: 0, fontFamily: "MTNRegular" }} size={14}>
                    Points building period has ended
                  </StyledText>
                </>) :
                  <>
                    <img style={{ marginBottom: "10px" }} src={GrowthCurve} />
                    <StyledText style={{ margin: 0, fontFamily: "MTNRegular" }} size={14}>
                      Points building ends in
                    </StyledText>
                    <StyledText style={{ margin: 0 }} size={20}>{captureCountdown}</StyledText>
                  </>
              }
            </PointsInfoCard>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const LeaderboardButton = ({ onClick }) => (
  <Button
    style={{
      margin: "10px 0 5px 0",
      padding: "5px 6px",
      display: "inline-block",
    }}
    onClick={onClick}
    color={"white"}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <WinnersIcon width={13} />
      <StyledText
        size={12}
        style={{
          margin: "2px 0 0 0",
          padding: "0 5px",
          fontFamily: "MTNRegular",
        }}
        color={"black"}
      >
        {"Leaderboard"}
      </StyledText>
      <ChevronRightArrow fill={"#000"} width={8} />
    </div>
  </Button>
);

const PointsInfoCard = styled.div`
  background: #fff;
  padding: 30px;
  margin: 20px;
  border-radius: 10px;
  text-align: center;
`;

const MainHolder = styled.div`
  display: grid;
  align-content: space-between;
  grid-template-rows: auto auto 1fr;
  overflow: hidden;
  scrollbar-width: none;
  background-color: ${({ activeTheme }) => activeTheme};
  height: 700px;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Body = styled.div`
  padding: 10px;
  margin: 5px;
`;
const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 0px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

export default CapturenSharePoints;
